import React from 'react';

const ACCENTS = {
  red: 'from-slate-950 via-red-900 to-rose-700',
  blue: 'from-slate-950 via-sky-900 to-cyan-700',
  green: 'from-slate-950 via-emerald-900 to-teal-700',
  purple: 'from-slate-950 via-violet-900 to-fuchsia-700',
  amber: 'from-slate-950 via-amber-800 to-orange-700'
};

const PageHero = ({ eyebrow, title, subtitle, accent = 'red', actions, stats = [] }) => {
  return (
    <section className={`relative overflow-hidden rounded-3xl bg-gradient-to-br ${ACCENTS[accent]} text-white shadow-xl`}>
      <div className="absolute inset-0 opacity-25 bg-[radial-gradient(circle_at_15%_20%,#fff,transparent_30%),radial-gradient(circle_at_88%_0%,#fbbf24,transparent_28%)]" />
      <div className="relative p-5 md:p-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            {eyebrow && (
              <p className="text-[11px] uppercase tracking-[0.28em] text-white/70">{eyebrow}</p>
            )}
            <h1 className="text-2xl md:text-3xl font-black mt-1">{title}</h1>
            {subtitle && <p className="text-white/75 text-sm mt-1">{subtitle}</p>}
          </div>
          {actions}
        </div>

        {stats.length > 0 && (
          <div className={`grid gap-3 mt-5 ${stats.length > 3 ? 'grid-cols-2 md:grid-cols-4' : 'grid-cols-2 md:grid-cols-3'}`}>
            {stats.map((stat) => (
              <div key={stat.label} className="rounded-2xl bg-white/10 border border-white/15 backdrop-blur-sm p-3">
                <p className="text-[11px] text-white/70">{stat.label}</p>
                <p className="text-xl md:text-2xl font-black mt-0.5">{stat.value}</p>
                {stat.hint && <p className="text-[11px] text-white/60 mt-1">{stat.hint}</p>}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default PageHero;
